/** Termin als .ics herunterladen oder Google-Calendar-Link öffnen */

function pad(n) {
  return String(n).padStart(2, '0');
}

function toIcsUtc(d) {
  return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
}

export function parseAppointmentStart({ dateIso, time = '09:00', fallback = new Date() }) {
  if (dateIso && /^\d{4}-\d{2}-\d{2}$/.test(dateIso)) {
    const [h, m] = String(time || '09:00').split(':').map(Number);
    const d = new Date(`${dateIso}T00:00:00`);
    d.setHours(h || 9, m || 0, 0, 0);
    if (Number.isFinite(d.getTime())) return d;
  }
  const fb = fallback instanceof Date ? fallback : new Date(fallback);
  return Number.isFinite(fb.getTime()) ? fb : new Date();
}

export function buildIcsEvent({ title, description, location, start, durationMinutes = 30 }) {
  const end = new Date(start.getTime() + durationMinutes * 60 * 1000);
  const uid = `crm-${Date.now()}@adstark-crm`;
  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//MittelBoost CRM//DE',
    'CALSCALE:GREGORIAN',
    'METHOD:PUBLISH',
    'BEGIN:VEVENT',
    `UID:${uid}`,
    `DTSTAMP:${toIcsUtc(new Date())}`,
    `DTSTART:${toIcsUtc(start)}`,
    `DTEND:${toIcsUtc(end)}`,
    `SUMMARY:${(title || 'CRM Termin').replace(/[,;\\]/g, ' ')}`,
  ];
  if (description) lines.push(`DESCRIPTION:${String(description).replace(/\n/g, '\\n').replace(/[,;]/g, ' ')}`);
  if (location) lines.push(`LOCATION:${String(location).replace(/[,;\\]/g, ' ')}`);
  lines.push('END:VEVENT', 'END:VCALENDAR');
  return lines.join('\r\n');
}

export function downloadIcsEvent(opts) {
  const ics = buildIcsEvent(opts);
  const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `termin-${(opts.leadName || 'lead').replace(/\s+/g, '-').slice(0, 40)}.ics`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function buildGoogleCalendarUrl({ title, description, location, start, durationMinutes = 30 }) {
  const end = new Date(start.getTime() + durationMinutes * 60 * 1000);
  const fmt = (d) => `${d.toISOString().replace(/[-:]/g, '').split('.')[0]}Z`;
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: title || 'CRM Termin',
    dates: `${fmt(start)}/${fmt(end)}`,
  });
  if (description) params.set('details', description);
  if (location) params.set('location', location);
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export function openAppointmentCalendar(lead, { dateIso, time, note } = {}) {
  const start = parseAppointmentStart({ dateIso, time });
  const title = `Termin: ${lead?.name || 'Lead'}${lead?.company ? ` (${lead.company})` : ''}`;
  const description = [note, lead?.tel && lead.tel !== '–' ? `Tel: ${lead.tel}` : '', lead?.email && lead.email !== '–' ? lead.email : ''].filter(Boolean).join('\n');
  const opts = { title, description, location: lead?.city && lead.city !== '–' ? lead.city : '', start, leadName: lead?.name };
  downloadIcsEvent(opts);
  return buildGoogleCalendarUrl(opts);
}
